import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.webp'


const _hoisted_1 = { class: "desktop-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo",
  loading: "lazy"
}, null, -1)
const _hoisted_3 = { class: "nav-bar" }
const _hoisted_4 = { class: "nav-list" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.youtube.com/@TheVideoGameVault",
    target: "_blank",
    class: "btn-secondary"
  }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "fa fa-youtube",
      "aria-hidden": "true"
    }),
    /*#__PURE__*/_createTextVNode(" Youtube ")
  ])
], -1)
const _hoisted_8 = { class: "mobile-header" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo",
  loading: "lazy"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "bar bar-one" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "bar bar-two" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "bar bar-three" }, null, -1)
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "nav-list" }
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.youtube.com/@TheVideoGameVault",
  class: "nav-list youtube-button btn-secondary",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-youtube",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode(" Youtube ")
], -1)

import { ref } from "vue";

const title = "The Video Game Vault";
const email = "info@thevideogamevault.com"

export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  setup(__props) {

const isNavActive = ref<boolean>(false)

const menuClick = () => {
    isNavActive.value = !isNavActive.value
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "nav-logo"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createElementVNode("h5", { class: "logo-name" }, _toDisplayString(title))
        ]),
        _: 1
      }),
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/articles",
              class: "nav-link"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Articles")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: "/videos",
              class: "nav-link"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Videos")
              ]),
              _: 1
            })
          ]),
          _hoisted_7
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "nav-logo"
      }, {
        default: _withCtx(() => [
          _hoisted_9,
          _createElementVNode("h5", { class: "logo-name" }, _toDisplayString(title))
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        class: _normalizeClass(["nav-toggle", { change: isNavActive.value }]),
        onClick: menuClick
      }, _hoisted_13, 2),
      _createElementVNode("nav", {
        class: _normalizeClass(["nav-bar", { 'nav-open': isNavActive.value }]),
        id: "navbar"
      }, [
        _createElementVNode("ul", _hoisted_14, [
          _createElementVNode("li", {
            class: "nav-item",
            onClick: menuClick
          }, [
            _createVNode(_component_router_link, {
              to: "/articles",
              class: "nav-link"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Articles")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", {
            class: "nav-item",
            onClick: menuClick
          }, [
            _createVNode(_component_router_link, {
              to: "/videos",
              class: "nav-link"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Videos")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", {
            class: "nav-item",
            onClick: menuClick
          }, [
            _createElementVNode("a", {
              class: "nav-link",
              href: 'mailto:' + email + '?subject=Contact Form - TheVideoGameVault.com'
            }, _toDisplayString(email), 8, _hoisted_15)
          ])
        ]),
        _hoisted_16
      ], 2)
    ])
  ]))
}
}

})